const translations = {
  en: {
    translations: {
      'Read the music': 'Read the music',
      Play: 'Play',
      Pause: 'Pause',
      Clef: 'Clef',
      Running: 'Running',
      Volume: 'Volume',
      Scale: 'Scale',
      Instrument: 'Instrument',
      'Time Signature': 'Time Signature',
      Tempo: 'Tempo',
      Piano: 'Piano',
      Computer: 'Computer',
      Treble: 'Treble',
      Bass: 'Bass',
      'Contribute in your language!': 'Contribute in your language!',
      'You can contribute by adding your own translation in your language!':
        'You can contribute by adding your own translation in your language!',
      'Two ways of doing this:': 'Two ways of doing this:',
      'Send me an email at': 'Send me an email at',
      'Contribute directly using': 'Contribute directly using',
      'Language changed to': 'Language changed to',
      Credits: 'Credits',
      'Site creator': 'Site creator',
      'Flags SVG Icons': 'Flags SVG Icons',
      'UI Design': 'UI Design',
      'Notation-0': 'International notation',
      'Notation-1': 'Latin notation',
      Shortcuts: 'Shortcuts',
      Space: 'Space',
      'Play/Pause': 'Play/Pause',
      'Up arrow': 'Up arrow',
      'Change scale up one half a tone': 'Change scale up one half a tone',
      'Down arrow': 'Down arrow',
      'Change scale down one half a tone': 'Change scale down one half a tone',
      'Left arrow': 'Left arrow',
      'Accelerate tempo up 20 bpm': 'Accelerate tempo up 20 bpm',
      'Right arrow': 'Right arrow',
      'Decelerate tempo up 20 bpm': 'Decelerate tempo up 20 bpm',
      'Test All Notes': 'Test All Notes',
      'notes available': 'notes available',
      Stop: 'Stop',
      'Play All Notes': 'Play All Notes',
      'Next Note': 'Next Note',
      'Now playing': 'Now playing',
      'All Available Notes': 'All Available Notes',
      'Click on any note to play it individually': 'Click on any note to play it individually',
      Home: 'Home',
      'Main piano practice interface': 'Main piano practice interface',
      'Test Notes': 'Test Notes',
      'Sequential note testing interface': 'Sequential note testing interface',
      Chords: 'Chords',
      'Chord practice and learning': 'Chord practice and learning',
      Changelog: 'Changelog',
      'Version history and updates': 'Version history and updates',
      'Navigation Menu': 'Navigation Menu',
      Beta: 'Beta',
      Ready: 'Ready',
      'In Progress': 'In Progress',
      Experimental: 'Experimental',
    },
  },
  fr: {
    translations: {
      'Read the music': 'Lire la musique',
      Play: 'Jouer',
      Pause: 'Pause',
      Clef: 'Clé',
      Running: 'Jouer',
      Volume: 'Volume',
      Scale: 'Gamme',
      Instrument: 'Instrument',
      'Time Signature': 'Signature temps',
      Tempo: 'Tempo',
      Piano: 'Piano',
      Computer: 'Ordinateur',
      Treble: 'Sol',
      Bass: 'Fa',
      'Contribute in your language!': 'Contribuez dans votre langue !',
      'You can contribute by adding your own translation in your language!':
        'Vous pouvez contribuer en ajoutant votre propre traduction dans votre langage !',
      'Two ways of doing this:': 'Deux façons de procéder :',
      'Send me an email at': 'Envoyez-moi un email à',
      'Contribute directly using': 'Contribuer directement en utilisant',
      'Language changed to': 'Langue changée en',
      Credits: 'Crédits',
      'Site creator': 'Créateur du site',
      'Flags SVG Icons': 'Icones SVG des drapeaux',
      'UI Design': "Design d'interface",
      'Notation-0': 'Notation internationale',
      'Notation-1': 'Notation latine',
      Shortcuts: 'Raccourcis',
      Space: 'Espace',
      'Play/Pause': 'Jouer/Pause',
      'Up arrow': 'Flèche du haut',
      'Change scale up one half a tone': "Augmenter la gamme d'un demi-ton",
      'Down arrow': 'Flèche du bas',
      'Change scale down one half a tone': "Baisser la gamme d'un demi-ton",
      'Left arrow': 'Flèche gauche',
      'Accelerate tempo up 20 units': 'Accélerer le tempo de 20 bpm',
      'Right arrow': 'Flèche droite',
      'Decelerate tempo up 20 units': 'Ralentir le tempo de 20 bpm',
      'Test All Notes': 'Tester toutes les notes',
      'notes available': 'notes disponibles',
      Stop: 'Arrêter',
      'Play All Notes': 'Jouer toutes les notes',
      'Next Note': 'Note suivante',
      'Now playing': 'En cours de lecture',
      'All Available Notes': 'Toutes les notes disponibles',
      'Click on any note to play it individually':
        'Cliquez sur une note pour la jouer individuellement',
      Home: 'Accueil',
      'Main piano practice interface': 'Interface principale de pratique du piano',
      'Test Notes': 'Test des notes',
      'Sequential note testing interface': 'Interface de test séquentiel des notes',
      Chords: 'Accords',
      'Chord practice and learning': 'Pratique et apprentissage des accords',
      Changelog: 'Historique',
      'Version history and updates': 'Historique des versions et mises à jour',
      'Navigation Menu': 'Menu de navigation',
      Beta: 'Beta',
      Ready: 'Prêt',
      'In Progress': 'En cours',
      Experimental: 'Expérimental',
    },
  },
};

export default translations;

export const languages = {
  en: 'English',
  fr: 'Français',
};
